<template>
		<div class="content">
		  detail
		</div>
</template>

<script>
import { games } from '../../assets/game_data'
export default {
	data() {
		return {
			initData:null, //
			langIndex:Number(localStorage.getItem('currentLangIndex') || '2'), //语言类型index
			gameKey:''
		}
	},
	mounted(){
		setTimeout(function(){
			document.querySelectorAll('.p-header img').forEach(v=>{
				v.classList.remove('ec-fade-in-b');
			})
		},1500)
	},
	created(){
		this.gameKey = this.$route.path.split('/')[2];
		//
		this.initData = games[this.gameKey] ;
	},
    watch:{
       '$store.state.langPack':function(){
            this.langIndex = Number(localStorage.getItem('currentLangIndex'));
       }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
